<template lang="pug">
    .list-container-center
        v-sheet
            v-progress-circular(
                v-if="loading"
                indeterminate
                color="primary"
                :size="100"
            )
        v-card(
          v-if="promo_details_list.length > 0"
        )
            v-img(
              contain
              content-class="merchant-image"
              height="240"
              :src="promo_details_list[0].promo_imageurl"
            )
            v-card-title(
                class="mt-2 text-h1"
                style="@media(max-width: 1264px) font-size: 50%;"
            ) {{ promo_details_list[0].promo_name }}
            v-chip(
            small
            outlined
            class="ml-4 mt-2 mb-2 red"
            label text-color="red darken-4"
            ) {{ promoCodeAvailability }} coupons available for redemption
            v-card-title(
                class="text-h3"
              ) PROMO CODE: {{ promo_details_list[0].promo_code }}
            v-card-text Valid until: {{ parseDate(promo_details_list[0].promo_enddate) }}
            v-divider.hide-on-desktop
            v-card-text {{ promo_details_list[0].promo_description }}
            v-card-actions
                v-btn(
                    :class="'green'"
                    style="outline: none;"
                    label text-color="white"
                    @click="redeemPromo()"
                ) REDEEM
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import parseDate from "@/mixins/parseDate";

export default {
  mixins: [parseDate],
  data() {
    return {
      promo_details_list: [],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  mounted() {
    this.getPromotionDetailsList();
  },
  computed: {
    promoCodeAvailability() {
      return (
        this.promo_details_list[0].promo_stock -
        this.promo_details_list[0].promo_usecount
      );
    }
  },
  methods: {
    getPromotionDetailsList() {
      let url = config.promotionDetailUrl();

      var json = {
        params: {
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken,
          promo_id: this.$route.params.promoID
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.promo_details_list = response.body.data;
              } else {
                this.$swal(
                  this.$t("error.get_merchant_banner"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_banner"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_banner"),
            response.body.message,
            "error"
          );
        });
    },
    redeemPromo() {
      // Insert code to redeem promo
    }
  }
};
</script>
